function sortGrids(order) {
  document.querySelectorAll('.events-list__grid').forEach((grid) => {
    const cards = Array.from(grid.querySelectorAll('.events-list__card'));
    if (cards.length === 0) return;

    cards.sort((a, b) => {
      const dateA = a.dataset.date || '';
      const dateB = b.dataset.date || '';
      if (dateA === dateB) return 0;
      const comparison = dateA < dateB ? -1 : 1;
      return order === 'asc' ? comparison : -comparison;
    });

    cards.forEach((card) => grid.appendChild(card));
  });
}

sortGrids('desc');

document.querySelectorAll('.events-list__sort-toggle').forEach((toggle) => {
  toggle.addEventListener('click', () => {
    const currentOrder = toggle.dataset.order === 'asc' ? 'asc' : 'desc';
    const nextOrder = currentOrder === 'asc' ? 'desc' : 'asc';

    sortGrids(nextOrder);

    toggle.dataset.order = nextOrder;
    const label = toggle.querySelector('.events-list__sort-label');
    if (label) {
      label.textContent = nextOrder === 'asc' ? 'Oldest first' : 'Newest first';
    }
  });
});
